module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/images/bg.b55204b3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/images/bg.png
// module id = 3083
// module chunks = 11